exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row[data-v-8f9b93ea]{display:-webkit-box;display:-ms-flexbox;display:flex;flex-wrap:wrap}.row>[class*=col-][data-v-8f9b93ea]{display:flex;flex-direction:column}.up-div[data-v-8f9b93ea]{position:fixed;bottom:30px;right:30px}.row.container[data-v-8f9b93ea]:after,.row.container[data-v-8f9b93ea]:before,.row.row[data-v-8f9b93ea]:after,.row.row[data-v-8f9b93ea]:before{content:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f9b93ea","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/list/Products.vue
// module id = 82
// module chunks = 0 1 2